import React from 'react'
import Alert from "react-bootstrap/Alert"
import { NavLink, Redirect } from "react-router-dom"

import Constants, { appConfig } from '../../config.js'
import { save_localcache_encrypted_wallet_backup, UserContext } from "../../Contexts/UserContext/UserContext.js"
import { getLog } from '../../helpers/helpers.js'
// import {save_localcache_encrypted_wallet_backup} from "./UserContext/UserContext.js"

import './wallet_password.css'
import { ButtonPrimary, ButtonPrimaryOutlined } from '../../components/Buttons.js'



function savefile_browsermode(filename, data) {
    var blob = new Blob([data], { type: 'text/csv' });
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
}

// TODO convert into functional component
class Wallet_Password extends React.Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.classname = "Wallet_Password: "

        this.state = {
            redirect: false,
            mnemonic: "",
            // filename: "wallet_" + appConfig.name + "_",
            filename: "TokkenR_wallet_",
            extension: "." + appConfig.name.toLowerCase(),
            password: "",
            password_confirmation: "",
            validpassword: false,
            validpassword_confirmation: false,
            validpassword_notempty: false,
            rememberDevice: false,    // opt-in: store encrypted blob in localStorage
            downloadBackup: true,     // whether to download the encrypted backup file
        }

        this.componentDidMount = this.componentDidMount.bind(this)
        this.handleChange_password = this.handleChange_password.bind(this)
        this.handleChange_password_confirmation = this.handleChange_password_confirmation.bind(this)
        this.handleChange_rememberDevice = this.handleChange_rememberDevice.bind(this)
        this.handleChange_downloadBackup = this.handleChange_downloadBackup.bind(this)
        this.is_confirmation_valid = this.is_confirmation_valid.bind(this)
        this.is_password_valid = this.is_password_valid.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleContinue = this.handleContinue.bind(this)
        this.download_backup_file = this.download_backup_file.bind(this)
    }


    componentDidMount() {
        this.setState({
            mnemonic: this.context.mnemonic,
        })
    }


    handleKeyDown(e) {
        if (e.key === 'Enter') {
            if (this.is_password_valid(this.state.password) && this.is_confirmation_valid()) {
                this.handleContinue()
            }
        }
    }


    handleChange_rememberDevice(e) {
        this.setState({ rememberDevice: e.target.checked })
    }

    handleChange_downloadBackup(e) {
        this.setState({ downloadBackup: e.target.checked })
    }


    is_confirmation_valid() {
        return this.state.password == this.state.password_confirmation
    }


    handleChange_password_confirmation(event) {
        var password_confirmation = event.target.value

        this.setState({
            password_confirmation: password_confirmation,
            validpassword_confirmation: false,
        }, () => {  // callback
            const is_confirmation_valid = this.is_confirmation_valid()
            this.setState({ validpassword_confirmation: is_confirmation_valid })
        })
    }

    is_password_valid(currpassword) {
        var is_password_valid = false

        var letter = document.getElementById("letter");
        var capital = document.getElementById("capital");
        var number = document.getElementById("number");
        var length = document.getElementById("length");
        document.getElementById("psw-message").style.display = "block";
        /*
        var nb_cond_valid = 0;
        var nb_cond_goal = 4;

        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g;
        if(currpassword.match(lowerCaseLetters)) {  
            letter.classList.remove("neutral");
            letter.classList.add("valid");
            nb_cond_valid++;
        } else {
            letter.classList.remove("valid");
            letter.classList.add("neutral");
        }
        
        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g;
        if(currpassword.match(upperCaseLetters)) {  
            capital.classList.remove("neutral");
            capital.classList.add("valid");
            nb_cond_valid++;
        } else {
            capital.classList.remove("valid");
            capital.classList.add("neutral");
        }
    
        // Validate numbers
        var numbers = /[0-9]/g;
        if(currpassword.match(numbers)) {  
            number.classList.remove("neutral");
            number.classList.add("valid");
            nb_cond_valid++;
        } else {
            number.classList.remove("valid");
            number.classList.add("neutral");
        }
        
        // Validate length
        if(currpassword.length >= 8) {
            length.classList.remove("neutral");
            length.classList.add("valid");
            nb_cond_valid++;
        } else {
            length.classList.remove("valid");
            length.classList.add("neutral");
        }

        if(nb_cond_valid == nb_cond_goal) {
            is_password_valid = true
        }
        else is_password_valid = false
        */

        // new version, much more free since we only require 1 char
        if (currpassword.length > 0) {  // at least 1 char
            // confirmation.style.display = "block"
            is_password_valid = true
        } else {
            // confirmation.style.display = "none"
            is_password_valid = false
        }
        return is_password_valid
    }



    handleChange_password(event) {
        var currpassword = event.target.value

        this.setState({
            password: currpassword,
            validpassword: false,
            validpassword_confirmation: false,
            validpassword_notempty: false,
        }, () => {  // callback

            // When the user clicks on the password field, show the message box
            var myInput = event.target
            // var myInput = document.getElementById("psw");
            myInput.onfocus = function() {
                document.getElementById("psw-message").style.display = "block";
            }
            /* // When the user clicks outside of the password field, hide the message box
            myInput.onblur = function() {
                document.getElementById("psw-message").style.display = 'none';
            } */

            const is_password_valid = this.is_password_valid(currpassword)
            this.setState({
                validpassword: is_password_valid,
            }, () => {  // callback

                this.setState({
                    validpassword_confirmation: this.is_confirmation_valid(),
                    validpassword_notempty: this.state.password.length > 0,
                })
            })
        })

    }



    /**
     * Main continue handler: saves the password via context (so the session
     * encrypted blob gets written), optionally downloads the encrypted backup
     * file, then redirects to the wallet.
     *
     * The download is now optional — the user can skip it if they're on a
     * device they don't fully trust and don't want to leave a file trace.
     */
    async handleContinue(event = null) {
        if (event) event.preventDefault()
        const function_id = this.classname + "handleContinue(): "
        const log = getLog(function_id)

        // 1. Optionally download the encrypted backup file
        if (this.state.downloadBackup) {
            await this.download_backup_file()
        } else {
            log("user chose to skip backup file download")
        }

        // 2. Save an encrypted session blob so the user stays logged in
        //    across refresh. This is needed here because for the create_new_wallet
        //    and restore_from_seed flows, update_from_mnemonic_noreload was called
        //    by the previous screen BEFORE the password was available, so the
        //    session blob wasn't saved there.
        if (this.context.mnemonic) {
            this.context.save_session_encrypted_wallet(this.state.password, this.state.rememberDevice)
        }

        // 3. Redirect to the wallet
        this.setState({ redirect: true })
    }


    /**
     * Generates the encrypted backup file and saves it to disk (Electron)
     * or triggers a browser download (web).
     */
    async download_backup_file() {
        const function_id = this.classname + "download_backup_file(): "
        const log = getLog(function_id)

        let data = this.context.generateBackupFile(this.state.password)
        data = JSON.stringify(data);

        let filename = this.state.filename + this.context.walletname + this.state.extension

        if (!Constants.IS_WEB_BUILD) {
            // Electron: show save dialog
            let defaultpath = window.electron.getAppGetPath('documents') + "/"

            let savePath = window.electron.showSaveDialogSync({
                defaultPath: defaultpath + filename,
                properties: ['createDirectory', 'showOverwriteConfirmation']
            })

            if (!savePath) {
                let errmess = function_id + "showSaveDialogSync(): error getting path of file to save"
                window.electron.openDialogShowMessageBox({ title: "Erreur", message: errmess })
                log(errmess)
                throw errmess
            }

            log("savePath:", savePath)

            try {
                await window.electron.writeFileSync(savePath, data)
            }
            catch (err) {
                let errmess = function_id + 'an error ocurred with file saving ' + err.message;
                window.electron.openDialogShowMessageBox({ title: "Erreur", message: errmess })
                log(errmess)
                throw errmess
            }

            // save a local copy in the app path cache for future reopenings
            if (this.context.address_owner) {
                log("saving backup in local cache, address=", this.context.address_owner)
                save_localcache_encrypted_wallet_backup(this.context.address_owner, data)
            }
            else {
                console.error(function_id + "this.context.address_owner is not set.")
            }

            let message = "Fichier sauvegardé avec succès: " + filename
            window.electron.openDialogShowMessageBox({ title: "Information", message: message })
        }
        else {
            // Web: trigger browser download
            savefile_browsermode(filename, data)
        }
    }


    render() {
        const function_id = this.classname + "render(): "
        const log = getLog(function_id)

        if (this.state.redirect === true) {
            return (
                <Redirect to="/wallet" push /> //push to not reload page
            )
        }

        var nextbuttonstyle = {}

        log(" this.state.validpassword = " + this.state.validpassword
            + "\n this.state.validpassword_confirmation = " + this.state.validpassword_confirmation)

        if (!this.state.validpassword || !this.state.validpassword_confirmation) {
            nextbuttonstyle = { pointerEvents: "none", backgroundColor: "gray" }
        }

        return (
            <div className="mode-selection-style">
                <h2>
                    {Constants.PASSWORD_TITLE}
                </h2>
                <br />

                <p className="main-text-page">
                    {Constants.PASSWORD_INFO}
                </p>
                <br />

                <Alert variant="warning" style={{ fontSize: "18px" }}>
                    <i className="fa fa-info-circle" style={{ fontSize: "24px" }} /> &nbsp;
                    {Constants.PASSWORD_WARN}
                </Alert>
                <br />

                {/* Form to complete */}

                <div className="main-text-page">
                    <div className="input_style" style={{ marginLeft: "2.5em" }}>
                        <div>
                            <input type="password"
                                value={this.state.password}
                                onChange={this.handleChange_password}
                                onKeyDown={this.handleKeyDown}
                                id="psw" name="psw"
                                placeholder="Type your password"
                                style={{ width: "18em" }}
                            />
                            <br /><br />
                            <input type="password"
                                value={this.state.password_confirmation}
                                onChange={this.handleChange_password_confirmation}
                                onKeyDown={this.handleKeyDown}
                                id="psw" name="psw"
                                placeholder="Type it again to confirm"
                                style={{ width: "18em" }}
                            />
                        </div>
                    </div>
                </div>

                <div id="psw-message">
                    {/*
                    <p className="main-text-psw">
                        Force du mot de passe:
                    </p>
                    */}
                    <div className="psw-check-list">
                        {/*
                        <p id="letter" className="neutral">
                            Lettres minuscules
                        </p>
                        <p id="capital" className="neutral">
                            Lettres majuscules
                        </p>
                        <p id="number" className="neutral">
                            Chiffres
                        </p>
                        <p id="length" className="neutral">
                            8 caractères ou plus
                        </p>
                        */}
                        <p id="not-empty" className={this.state.validpassword_notempty ? "valid" : "invalid"}>
                            Password field cannot be empty
                        </p>

                        {this.state.validpassword_notempty ?
                            <p id="confirmation" className={this.state.validpassword_confirmation ? "valid" : "invalid"}>
                                Password confirmation field should match
                            </p>
                            : null}
                    </div>
                </div>
                <br />

                {/* Download backup file option */}
                <div className="main-text-page" style={{ maxWidth: "500px", margin: "0 auto" }}>
                    <Alert variant="info" style={{ fontSize: "16px", textAlign: "left" }}>
                        <label style={{ cursor: "pointer", display: "flex", alignItems: "flex-start", gap: "8px" }}>
                            <input
                                type="checkbox"
                                checked={this.state.downloadBackup}
                                onChange={this.handleChange_downloadBackup}
                                style={{ marginTop: "4px", transform: "scale(1.3)" }}
                            />
                            <span>
                                <b>{Constants.DOWNLOAD_BACKUP_QUESTION}</b><br />
                                <span style={{ fontSize: "14px" }}>{Constants.DOWNLOAD_BACKUP_INFO}</span>
                            </span>
                        </label>
                    </Alert>
                    <br />

                    {/* Remember device option */}
                    <Alert variant="secondary" style={{ fontSize: "16px", textAlign: "left" }}>
                        <label style={{ cursor: "pointer", display: "flex", alignItems: "flex-start", gap: "8px" }}>
                            <input
                                type="checkbox"
                                checked={this.state.rememberDevice}
                                onChange={this.handleChange_rememberDevice}
                                style={{ marginTop: "4px", transform: "scale(1.3)" }}
                            />
                            <span>
                                <b>{Constants.REMEMBER_DEVICE_QUESTION}</b><br />
                                <span style={{ fontSize: "14px" }}>{Constants.REMEMBER_DEVICE_INFO}</span>
                            </span>
                        </label>
                    </Alert>
                </div>
                <br />

                {/* Buttons */}

                <div className="bottom-buttons">
                    <div className="return-button">
                        <NavLink className="return-logo" to="/enter_wallet_name">
                            <ButtonPrimaryOutlined>
                                Back
                            </ButtonPrimaryOutlined>
                        </NavLink>
                    </div>
                    <div className="next-button">
                        <ButtonPrimary onClick={this.handleContinue} style={nextbuttonstyle}>
                            Next
                        </ButtonPrimary>
                    </div>
                </div>

                {/* make it easier to scroll if needed */}
                <div style={{ height: "40vh" }}>&nbsp;</div>

            </div>
        )
    }
}

export default Wallet_Password;
